import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useTitle } from './TitleContext'; // Import the provider
import medmentionnews1 from '../images/med-mention demo news 1.png';
import medmentionnews2 from '../images/med-mention demo news 2.png';
import medmentionsocial1 from '../images/med-mention demo social 1.png';
import medmentionsocial2 from '../images/med-mention demo social 2.png';
import './MediaMentions.css';

function MediaMentions() {
  const navigate = useNavigate()
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle("Media Mentions Tracker"); // Set the title for the home page
  }, [setTitle]);
  const goHome = () => {
    navigate('/');  // Navigate to the home page
    window.scrollTo(0, 0);  // Scroll to the top of the page
  };
  return (
    <div className="main-content">
        <h2>Live News Feed</h2>
        <div className="media-tracker-container">
            <img src={medmentionnews1} alt="Media Mentions News 1" />
            <img src={medmentionnews2} alt="Media Mentions News 2" />
        </div>

        <h2>Live Social Feed</h2>
        <div className="media-tracker-container">
            <img src={medmentionsocial1} alt="Media Mentions Social 1" />
            <img src={medmentionsocial2} alt="Media Mentions Social 2" />
        </div>
        <div className="tracker-info">
            <button onClick={goHome}>Return</button>
        </div>
    </div>

  );
}

export default MediaMentions;